import { render } from "./Chapters.vue?vue&type=template&id=2b540ebe"
import script from "./Chapters.vue?vue&type=script&lang=js"
export * from "./Chapters.vue?vue&type=script&lang=js"

import exportComponent from "/Users/stevenbedford/Documents/GitHub/icota-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/js/components/Blocks/Chapters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b540ebe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b540ebe', __exports__)) {
    console.log('reload')
    api.reload('2b540ebe', __exports__)
  }
  
  module.hot.accept("./Chapters.vue?vue&type=template&id=2b540ebe", () => {
    console.log('re-render')
    api.rerender('2b540ebe', render)
  })

}


export default __exports__